var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('cookie-banner-message');
import { breakpoints, theme } from '@shapeable/theme';
import { useLink } from '../hooks/use-link';
import { useCookieBannerFeaturesList } from '../context/cookie-banner-features-list-context';
export var CookieBannerMessageDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-weight: 500;\n    color: ", ";\n    margin-bottom: 0;\n  "], ["\n    font-weight: 500;\n    color: ", ";\n    margin-bottom: 0;\n  "])), theme.COLOR('strong'))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Title: styled.h1(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles)
};
export var CookieBannerMessage = function (props) {
  var className = props.className,
    privacyPath = props.privacyPath;
  var Link = useLink().Link;
  var featuresList = useCookieBannerFeaturesList();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Title, null, "Your choice regarding cookies:"), React.createElement("p", null, "This site uses cookies to deliver essential website functionality and analytics."), React.createElement("p", null, "By clicking \"ACCEPT ALL,\" you consent to the use of these cookies."), React.createElement("p", null, React.createElement("b", null, "Important:"), " select \"ACCEPT FUNCTIONAL ONLY\" to enable core website features listed below:", featuresList, React.createElement("p", null, "If you click \"REJECT ALL,\" certain core website functionalities, as mentioned above, will be disabled."), privacyPath && React.createElement("p", null, "For more information on the types of cookies we use, please read our ", React.createElement(Link, {
    href: privacyPath
  }, "Privacy Policy"), ".")));
};
CookieBannerMessage.cls = cls;
CookieBannerMessage.defaultProps = CookieBannerMessageDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;